import type { PlatformUsageLiveSession } from '../types';

export interface PlatformUsageLiveMetrics {
  activeSessions: number;
  activeUsers: number;
  activeTenants: number;
}

function uniqueCount(values: Array<string | null>): number {
  const seen = new Set<string>();
  for (const value of values) {
    if (value) seen.add(value);
  }
  return seen.size;
}

export function computeLiveMetrics(sessions: PlatformUsageLiveSession[]): PlatformUsageLiveMetrics {
  return {
    activeSessions: sessions.length,
    activeUsers: uniqueCount(sessions.map((s) => s.userExternalId ?? s.userId)),
    activeTenants: uniqueCount(sessions.map((s) => s.tenantExternalId ?? s.tenantId)),
  };
}
